import React, { createContext, useContext, useState, useEffect } from "react";
import { useAuthStudent } from "../../context/StudentLoginContext/StudentAuthContext";


const RoleContext = createContext();

export const StudentRoleProvider = ({ children }) => {
  const { student, loading: authLoading } = useAuthStudent();
  const [role, setRole] = useState(null); // Change initial state to null
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (authLoading) {
      setIsLoading(true); // If auth is loading, role should also be loading
    } else if (student) {
      setRole(student?.role || student?.student?.role || "");
      setIsLoading(false);
    } else {
      setRole(null); // Reset role if user logs out
      setIsLoading(false);
    }
  }, [student, authLoading]);

  return (
    <RoleContext.Provider value={{ role, setRole, isLoading }}>
      {children}
    </RoleContext.Provider>
  );
};

export const useStudentRole = () => useContext(RoleContext);
